//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {buttonType, children, disabled, id, onClick} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './MainHeaderBtn.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children,
  onClick: onClick,
  disabled?: disabled,
  buttonType?: buttonType
};

const MainHeaderBtn = (props: Props) => {
  const buttonType = props.buttonType ? props.buttonType : 'button';
  return (
    <button type={buttonType} id={props.id} onClick={props.onClick} disabled={props.disabled}
         className={baseClass("MainHeaderBtn", props.addClasses)}>
      {props.children}</button>
  );
};

export default MainHeaderBtn;